import React from 'react';

import { FeatureFlagged, FeatureGatedVariant } from '../../../feature-gates/feature-flagged';
import { FeatureGates } from '../../../feature-gates/feature-gates';
import { OnMessageSendInput } from '../../../typescript-types/messages/on-message-send-type';
import { LegacyMultiLanguageMessageComposer } from '../legacy-multiple-language-message-composer';
import { MLMCProps, MultiLanguageMessageComposer } from '../multiple-language-message-composer';

type InputProps = {
  orgId: number;
};

type MultiLanguageFileUploadProps = InputProps & MLMCProps;

export type UseFileUploadType = {
  handleUploadClick: (file: File) => Promise<any>;
  handleDeleteFileClick: (urlFileMapping: UrlFileMapping) => () => void;
  urlFileMappings: UrlFileMapping[];
};

// TODO[PROD-3488]: remove component and allow uploads via the canUpload prop
export const MultipleLanguageFileUploadComposer = ({
  ...messageComposerProps
}: MultiLanguageFileUploadProps) => {
  const { onMessageSent, onSendMessage, allowSendWithVCard } = messageComposerProps;

  const handleSendMessageWithFileUploads =
    onSendMessage &&
    ((onMessageSendInput: OnMessageSendInput) => onSendMessage({ ...onMessageSendInput }));

  // only clear out urlFileMappings if the message was successfully sent. If not, keep the same
  // urlFileMappings so the user can still send the message with urls once they fix their errors
  const handleSuccessfulMessageSent = () => {
    if (onMessageSent) {
      onMessageSent();
    }
  };

  return (
    <>
      <FeatureFlagged
        variant={FeatureGatedVariant.HIDE_ON_FLAG}
        flagName={FeatureGates.INTEGRATED_MESSAGING}
      >
        <LegacyMultiLanguageMessageComposer
          {...messageComposerProps}
          onMessageSent={handleSuccessfulMessageSent}
          onSendMessage={handleSendMessageWithFileUploads}
          allowSendWithVCard={allowSendWithVCard}
          canUploadFile
        />
      </FeatureFlagged>
      <FeatureFlagged
        variant={FeatureGatedVariant.SHOW_ON_FLAG}
        flagName={FeatureGates.INTEGRATED_MESSAGING}
      >
        <MultiLanguageMessageComposer
          {...messageComposerProps}
          onMessageSent={handleSuccessfulMessageSent}
          onSendMessage={handleSendMessageWithFileUploads}
          allowSendWithVCard={allowSendWithVCard}
          canUploadFile
        />
      </FeatureFlagged>
    </>
  );
};
